import { FormBeforeSendError } from './FormBeforeSendError';

export class FormBeforeSendBotDetectedError extends FormBeforeSendError {
  constructor(message = 'We are unable to allow you to signup/sign in at the moment. Please reach out to us with any questions: <a class="link1" href="mailto:info@acretrader.com">info@acretrader.com</a>') {
    super(message);

    this.code = 'bot_detected';
  }
}
